import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assemblee-show',
  templateUrl: './assemblee-show.component.html',
  styleUrls: ['./assemblee-show.component.scss']
})
export class AssembleeShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
